import React, { useEffect, useState } from "react";

import axios from "axios";
import cup from "../../../../../../../../assets/images/cup 2.png";
import AllDataHeader from "../../../../../../../Reuseable/AllDataHeader";
import AuditionDistributed from "./AuditionDistributed";
import LoaderPost from "../../../../../../../Reuseable/LoaderPost";

const AuditionForDistributeVideo = () => {
  const [events, setEvents] = useState([]);
  const [buffer, setBuffer] = useState(true);
  useEffect(() => {
    axios.get("/api/audition-admin/audition/lives").then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setEvents(res.data.lives);
        
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title="Filter live auditions videos"
        image={cup}
        count={"Zero"}
      />
      {buffer ? (
        <LoaderPost />
      ) : (
        <AuditionDistributed
          data={events}
          distributeUrlLink={`/audition-admin/audition/round-video-distribute`}
        />
      )}
    </>
  );
};

export default AuditionForDistributeVideo;
